var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 70,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "url(#iconBook1Linear1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 31.0553C25 31.0553 37.7556 30.6862 45.8 31.8553C53.4485 32.9669 65 36.6553 65 36.6553V98.2553C65 98.2553 52.8354 96.6553 45 96.6553C37.1646 96.6553 25 98.2553 25 98.2553V31.0553Z",
    fill: "url(#iconBook1Linear2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 31.1105C105 31.1105 92.2444 30.7413 84.2 31.9105C76.5515 33.0221 65 36.7105 65 36.7105V98.3105C65 98.3105 77.1646 96.7105 85 96.7105C92.8354 96.7105 105 98.3105 105 98.3105V31.1105Z",
    fill: "url(#iconBook1Linear3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 37.0553C29.8 37.0553 36.451 36.9867 40.2 37.4553C43.949 37.9239 49 39.0553 49 39.0553V42.2553C49 42.2553 44.007 41.403 40.2 40.8553C36.4819 40.3204 29.8 40.2553 29.8 40.2553V37.0553Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 43.0553C29.8 43.0553 33.3693 42.8991 35.4 43.0553C37.4307 43.2115 40.2 43.4553 40.2 43.4553V45.0553C40.2 45.0553 37.4307 44.8115 35.4 44.6553C33.3693 44.4991 29.8 44.6553 29.8 44.6553V43.0553Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 56.6667C29.8 56.6667 36.6109 56.5711 43 56.9324C54.3999 57.5772 59.4 59.8553 59.4 59.8553V61.1838C59.4 61.1838 54.2 59.1618 43 58.5267C36.5954 58.1635 29.8 58.261 29.8 58.261V56.6667Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 63.3325C29.8 63.3325 36.6109 62.9711 43 63.3325C54.3999 63.9772 59.4 66.2553 59.4 66.2553V67.5839C59.4 67.5839 54.2 65.5619 43 64.9267C36.5954 64.5636 29.8 64.9268 29.8 64.9268V63.3325Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4 63.2158C99.4 63.2158 92.5891 62.8544 86.2 63.2158C74.8002 63.8605 69.8 66.1386 69.8 66.1386V67.4672C69.8 67.4672 75 65.4452 86.2 64.81C92.6046 64.4469 99.4 64.8101 99.4 64.8101V63.2158Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 69.8554C29.8 69.8554 36.6109 69.3712 43 69.7326C54.3999 70.3773 59.4 72.2554 59.4 72.2554V73.584C59.4 73.584 54.2 71.962 43 71.3269C36.5954 70.9637 29.8 71.4497 29.8 71.4497V69.8554Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4 69.7121C99.4 69.7121 92.5891 69.2279 86.2 69.5893C74.8002 70.234 69.8 72.1121 69.8 72.1121V73.4407C69.8 73.4407 75 71.8187 86.2 71.1835C92.6046 70.8204 99.4 71.3064 99.4 71.3064V69.7121Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 76.6552C29.8 76.6552 36.6109 75.6278 43 75.9891C54.3999 76.6339 59.4 78.2494 59.4 78.2494V79.578C59.4 79.578 54.2 78.2185 43 77.5834C36.5954 77.2202 29.8 78.2494 29.8 78.2494V76.6552Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4 76.2552C99.4 76.2552 94.2 75.5367 86.2 75.9892C74.8002 76.6339 69.8 78.512 69.8 78.512V79.8405C69.8 79.8405 75 78.2185 86.2 77.5834C94.6 77.1071 99.4 77.8495 99.4 77.8495V76.2552Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4 83.082V84.2695C87.4 84.2695 90.85 84.2092 93.1931 84.2695C95.5363 84.3299 99.4 84.6552 99.4 84.6552V83.4677C99.4 83.4677 95.5363 83.1424 93.1931 83.082C90.85 83.0216 87.4 83.082 87.4 83.082Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6 41.0552C70.6 41.0552 74.2758 39.9144 77.4 39.0552C80.5242 38.1961 86.6 37.8552 86.6 37.8552V53.8552C86.6 53.8552 82.233 53.6086 77 54.6552C73 55.4552 70.6 56.6552 70.6 56.6552V41.0552Z",
    fill: "url(#iconBook1Linear4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconBook1Linear1",
    x1: 0,
    y1: 0,
    x2: 130,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconBook1Linear2",
    x1: 64.2,
    y1: 64.6553,
    x2: 25,
    y2: 64.6553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D8E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconBook1Linear3",
    x1: 24.6,
    y1: 64.6552,
    x2: 105,
    y2: 64.6552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6BA6BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68805,
    stopColor: "#BAE4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BA6BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconBook1Linear4",
    x1: 86.7778,
    y1: 46.9999,
    x2: 70.3333,
    y2: 46.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435681,
    stopColor: "#629EA2",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#629EA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook1);
export default __webpack_public_path__ + "static/media/iconBook1.d03dc4ba7f6249d5389876d4c697a6a4.svg";
export { ForwardRef as ReactComponent };